"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartList = void 0;
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var Cart = __importStar(require("../../Actions/Cart"));
var ProductVariants_1 = __importDefault(require("../ProductVariants"));
function CartList(props) {
  var _this = this;
  var cartItems = props.cartItems,
    _a = props.disabled,
    disabled = _a === void 0 ? false : _a;
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var dataSource = cartItems.map(function (c, i) {
    return __assign(__assign({}, c), {
      index: i
    });
  });
  var removeFromCart = function (index) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 2, 3]);
            AppActions.setLoading(true);
            return [4 /*yield*/, Cart.removeFromCart(index)];
          case 1:
            _a.sent();
            return [3 /*break*/, 3];
          case 2:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };

  var renderCustomComponent = function (name, item) {
    return AppActions.renderCustomComponent({
      name: name,
      data: {
        item: item
      }
    });
  };
  var columns = [{
    title: '品項',
    dataIndex: 'index',
    key: 'info',
    render: function (index) {
      var _a;
      var item = dataSource.find(function (c) {
        return c.index === index;
      });
      return react_1.default.createElement(antd_1.Card, {
        key: index,
        size: "small",
        style: {
          maxWidth: 250
        },
        title: react_1.default.createElement("p", {
          style: {
            whiteSpace: 'pre-wrap'
          }
        }, item.name)
      }, react_1.default.createElement(antd_1.Image, {
        src: ((_a = item.product.images) === null || _a === void 0 ? void 0 : _a[0]) || '',
        fallback: "https://www.taiwang-puzzle.com/image/cache/catalog/%E5%AE%A2%E8%A3%BD%E8%B4%88%E7%A6%AE%E5%93%81%E6%8B%BC%E5%9C%96/cp-0020-500x500.jpg"
      }));
    },
    width: 250
  }, {
    title: '規格',
    dataIndex: 'index',
    key: 'config',
    render: function (index) {
      var item = dataSource.find(function (c) {
        return c.index === index;
      });
      return react_1.default.createElement(ProductVariants_1.default, {
        product: item.product,
        config: item.config,
        disabled: true,
        rowStyle: {
          justifyContent: 'flex-start'
        }
      });
    },
    width: 250
  }, {
    title: '小計',
    dataIndex: 'index',
    key: 'subtotal',
    render: function (index) {
      var item = dataSource.find(function (c) {
        return c.index === index;
      });
      return react_1.default.createElement("div", null, "$", item.amount);
    },
    width: 250
  }, {
    title: '其他',
    dataIndex: 'index',
    key: 'else',
    render: function (index) {
      var item = dataSource.find(function (c) {
        return c.index === index;
      });
      return renderCustomComponent('CART_CUSTOM_COLUMN', item);
    },
    width: 250
  }, {
    title: '動作',
    dataIndex: 'index',
    key: 'action',
    render: function (index) {
      return !disabled ? react_1.default.createElement(antd_1.Button, {
        onClick: function () {
          return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4 /*yield*/, removeFromCart(index)];
                case 1:
                  _a.sent();
                  return [2 /*return*/];
              }
            });
          });
        }
      }, "\u79FB\u9664") : null;
    },
    width: 150
  }];
  return react_1.default.createElement(antd_1.Table, {
    scroll: {
      x: 1000
    },
    pagination: false,
    dataSource: dataSource,
    columns: columns
  });
}
exports.CartList = CartList;
exports.default = CartList;